"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildReportBody = exports.getAppInfo = exports.getAgentInfo = exports.getCorrelationId = exports.CORRELATION_ID_HEADER = exports.INSTRUMENTATION_ENDPOINT_URI = exports.ErrorSourceType = void 0;
var uuid_1 = require("uuid");
var __1 = require("..");
var deviceInfo_1 = __importDefault(require("./deviceInfo"));
var common_1 = require("./../services/common");
var ErrorSourceType;
(function (ErrorSourceType) {
    ErrorSourceType["API_RESPONSE_ERROR"] = "API_RESPONSE_ERROR";
    ErrorSourceType["DATA_INTEGRITY_ERROR"] = "DATA_INTEGRITY_ERROR";
    ErrorSourceType["WIDGET_RENDER_ERROR"] = "WIDGET_RENDER_ERROR";
})(ErrorSourceType = exports.ErrorSourceType || (exports.ErrorSourceType = {}));
var API_ERROR_CODES_TO_NOT_REPORT = [201];
exports.INSTRUMENTATION_ENDPOINT_URI = '/logs';
exports.CORRELATION_ID_HEADER = 'x-agw-correlationId';
// function to construct the "x-correlation-id" header's value
var getCorrelationId = function (featureId, sourceName) {
    if (sourceName === void 0) { sourceName = ''; }
    var correlationId = "".concat(Date.now(), "-").concat((0, uuid_1.v4)());
    if (featureId) {
        correlationId = "FID-".concat(featureId, "-").concat(correlationId);
    }
    if (sourceName) {
        correlationId = "S-".concat(sourceName, "-").concat(correlationId);
    }
    return correlationId;
};
exports.getCorrelationId = getCorrelationId;
// Function to extract web/mobile agent information
var getAgentInfo = function () {
    return JSON.stringify(deviceInfo_1.default);
};
exports.getAgentInfo = getAgentInfo;
// function to extract the front app details : version
var getAppInfo = function () {
    return JSON.stringify({
        appVersion: "".concat(process.env.REACT_APP_VERSION)
        //ssmVersion: '13.9.0' // try to get the SSM package version
    });
};
exports.getAppInfo = getAppInfo;
var getErrorFromEffectException = function (e, correlationId) {
    return {
        error: e,
        requestDetails: { correlationId: correlationId },
        responseData: null
    };
};
// Function to build the body to send to instrumentation endpoint
var buildReportBody = function (error, errorSource, correlationId) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    //hide sensitive data in request config like password, bearer-token, iban
    error = (0, common_1.hideDataInAxiosError)("XXXXXX", error, ["password", "iban", "ibanLastFiveNumber", "newIban", "email", "streetAddress", "lieuDit", "addressComplement", "telMobile", "city", "zipCode"], ["Authorization", "g-recaptcha-response"]);
    var requestDetails = {
        url: (_b = (_a = error === null || error === void 0 ? void 0 : error.config) === null || _a === void 0 ? void 0 : _a.url) !== null && _b !== void 0 ? _b : '',
        httpVerb: (_d = (_c = error === null || error === void 0 ? void 0 : error.config) === null || _c === void 0 ? void 0 : _c.method) !== null && _d !== void 0 ? _d : '',
        headers: JSON.stringify((_f = (_e = error === null || error === void 0 ? void 0 : error.config) === null || _e === void 0 ? void 0 : _e.headers) !== null && _f !== void 0 ? _f : {}),
        payload: JSON.stringify((_h = (_g = error === null || error === void 0 ? void 0 : error.config) === null || _g === void 0 ? void 0 : _g.data) !== null && _h !== void 0 ? _h : {})
    };
    var responseDetails = {
        httpStatus: String((_k = (_j = error === null || error === void 0 ? void 0 : error.response) === null || _j === void 0 ? void 0 : _j.status) !== null && _k !== void 0 ? _k : '200'),
        response: JSON.stringify((_m = (_l = error === null || error === void 0 ? void 0 : error.response) === null || _l === void 0 ? void 0 : _l.data) !== null && _m !== void 0 ? _m : {})
    };
    var errorDetails = {
        name: error === null || error === void 0 ? void 0 : error.name,
        message: error === null || error === void 0 ? void 0 : error.message,
        stack: error === null || error === void 0 ? void 0 : error.stack,
        trace: ''
    };
    switch (errorSource) {
        case ErrorSourceType.API_RESPONSE_ERROR:
        case ErrorSourceType.DATA_INTEGRITY_ERROR:
            errorDetails = {
                name: error === null || error === void 0 ? void 0 : error.name,
                message: error === null || error === void 0 ? void 0 : error.message,
                stack: error === null || error === void 0 ? void 0 : error.stack,
                trace: ''
            };
            break;
        case ErrorSourceType.WIDGET_RENDER_ERROR:
            var exception = error.error, errorInfo = error.errorInfo;
            errorDetails = {
                name: exception === null || exception === void 0 ? void 0 : exception.name,
                message: exception === null || exception === void 0 ? void 0 : exception.message,
                stack: exception === null || exception === void 0 ? void 0 : exception.stack,
                trace: errorInfo
            };
            break;
        default:
    }
    return {
        level: 'ERROR',
        correlationId: correlationId,
        errorSource: errorSource,
        context: {
            agentInfo: (0, exports.getAgentInfo)(),
            frontInfo: (0, exports.getAppInfo)()
        },
        request: requestDetails,
        response: responseDetails,
        exception: JSON.stringify(errorDetails),
        error: errorDetails // not in CI with API
    };
};
exports.buildReportBody = buildReportBody;
var getCorrelationIdFromApiError = function (error, errorSource) {
    var _a, _b, _c;
    return (_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.config) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b[exports.CORRELATION_ID_HEADER]) !== null && _c !== void 0 ? _c : '';
};
// function to check and avoid report in infinite loop when there is an issue on instrumentation api
// const isErrorInInstrumenationApi = (
//     error: any,
//     errorSource: ErrorSourceType
// ): boolean => {
//     return (
//         errorSource == ErrorSourceType.AXIOS_INTERCEPTOR &&
//         error?.config?.url == INSTRUMENTATION_ENDPOINT_URI
//     );
// };
// function to check to avoir report duplication, because the error should be reported by the axios interceptor
var isNetworkErrorCatchedInSagaEffect = function (error, errorSource) {
    var _a;
    return (errorSource == ErrorSourceType.DATA_INTEGRITY_ERROR && ((_a = error === null || error === void 0 ? void 0 : error.config) === null || _a === void 0 ? void 0 : _a.url));
};
// function to check if it's an api error but not to report
var isNetworkErrorToNotReport = function (error, errorSource) {
    return (errorSource == ErrorSourceType.API_RESPONSE_ERROR &&
        API_ERROR_CODES_TO_NOT_REPORT.includes(error === null || error === void 0 ? void 0 : error.status));
};
// Function to report errors to an instrumentation endpoint or tracking service
var reportErrorToInstrumentation = function (error, errorSource, correlationId) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        console.log(reportErrorToInstrumentation.name, {
            error: error,
            errorSource: errorSource,
            correlationId: correlationId,
            url: (_a = __1.urlsConfig === null || __1.urlsConfig === void 0 ? void 0 : __1.urlsConfig.getURLs()) === null || _a === void 0 ? void 0 : _a.ADMIN_BASE_URL,
            isNetworkErrorCatchedInSagaEffect: isNetworkErrorCatchedInSagaEffect(error, errorSource),
            isNetworkErrorToNotReport: isNetworkErrorToNotReport(error, errorSource)
        });
        try {
            // cases to not report
            if (isNetworkErrorCatchedInSagaEffect(error, errorSource) ||
                isNetworkErrorToNotReport(error, errorSource)) {
                return [2 /*return*/];
            }
            // const correlationIdHeader =
            //     correlationId ?? getCorrelationIdFromApiError(error, errorSource);
            // const errorReport = buildReportBody(
            //     error,
            //     errorSource,
            //     correlationIdHeader
            // );
            // Report error to the instrumentation endpoint
            // const url =
            //     urlsConfig?.getURLs()?.ADMIN_BASE_URL +
            //     INSTRUMENTATION_ENDPOINT_URI;
            // await axios.post(url, errorReport, {
            //     headers: { [CORRELATION_ID_HEADER]: correlationIdHeader }
            // });
        }
        catch (reportError) {
            console.error('Error while reporting to instrumentation endpoint:', reportError);
        }
        return [2 /*return*/];
    });
}); };
exports.default = reportErrorToInstrumentation;
